.widgetWithBadge {
  // Honeycomb sets display:block via a :not() compound selector (specificity 0,2,0).
  // !important is the only clean override without leaking into Honeycomb's namespace.
  display: flex !important;
  align-items: center;
  gap: var(--hcr-spacing-2);
}

.badge {
  font-size: var(--hcr-font-size-small);
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #fff;
  border: 1px solid #fff;
  border-radius: 3px;
  padding: 2px var(--hcr-spacing-1);
  white-space: nowrap;
  line-height: 16px;
}
